import { FC, useMemo } from "react";
import styled from "styled-components";

import { useSelectItemsTranslate } from "@ryde/redux";
import {
  BookingStatusEnum,
  IStyledAttributes,
  useIsMobile,
} from "@ryde/shared";
import { MOBILE_BREAKPOINT } from "@ryde/theme";

import {
  IStatusIndicatorBookingControl,
  StatusIndicatorBookingConst,
} from "../../common";

interface IBookingStatusCell {
  status: BookingStatusEnum;
}

const BookingStatusCellStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "booking-status-cell",
})<IStatusIndicatorBookingControl>`
  width: 80px;
  height: 24px;
  background-color: ${props => props.$bgColor};
  border-inline-start: 2px solid ${props => props.$leftColor};
  color: ${props => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 400;
  border-radius: 3px;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 35px;
  }
`;

export const BookingStatusCell: FC<IBookingStatusCell> = ({ status }) => {
  const info = StatusIndicatorBookingConst[status];
  const { translateLabel } = useSelectItemsTranslate();
  const { isMobile } = useIsMobile();
  const statusText = useMemo(() => {
    // Optional chaining: a status this build does not know yet must not crash the grid.
    const text = translateLabel(info?.$translateKey) || "";

    if (!isMobile) {
      return text;
    }

    return text.at(0) || "";
  }, [info?.$translateKey, isMobile, translateLabel]);

  return (
    <BookingStatusCellStyled {...info}>{statusText}</BookingStatusCellStyled>
  );
};
